import { useQuery } from "@tanstack/react-query";
import type { PartnerKitResponse } from "@mfa-aff/shared";
import { kitMock } from "../mocks/kit";
import { API_BASE } from "./config";
import { get } from "./client";
import { partnerPaths } from "./paths";

/** `GET /kit`: selling points, uploaded banners and captions (`{ref_code}` / `{link}` already filled in). */
export const useKit = () => useQuery({ queryKey: ["partner", "kit"], queryFn: () => get<PartnerKitResponse>(partnerPaths.kit, kitMock) });

/** Banner `url`s are served by the API at `/uploads/…`; prefix the API origin when it is not same-origin. */
export const assetUrl = (url: string) => (url.startsWith("/") ? `${API_BASE}${url}` : url);
